import { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';

// utils
import useExternalScript from 'utils/hooks/use-external-script';

interface Socket {
  destroy: () => void;
}

interface EasyXDM {
  whenReady: (callback: () => void) => void;
  Socket: new (args: {
    remote: string;
    container: string;
    onMessage: (message: string) => void;
  }) => Socket;
}

declare global {
  const easyXDM: EasyXDM;
}

interface IframeProps {
  src: string;
}

export default function Iframe({ src }: Readonly<IframeProps>) {
  const [easyXdmId, setEasyXdmId] = useState<string | undefined>();

  const easyXdmLoaded = useExternalScript({
    id: 'easyxdm-script',
    src: '/js/easyxdm.js',
  });

  useEffect(() => {
    setEasyXdmId(`iframe-${uuidv4()}`);
  }, []);

  useEffect(() => {
    if (!easyXdmLoaded || !easyXdmId) {
      return () => {};
    }

    // easyXDM - needs to be loaded client side only or causes error 500
    easyXDM.whenReady(() => {
      const socket = new easyXDM.Socket({
        remote: src,
        container: easyXdmId,
        onMessage(message) {
          const xdmIframe = document.getElementById(easyXdmId)?.querySelector('iframe');
          if (xdmIframe) {
            xdmIframe.height = `${message}px`;
          }
        },
      });

      return () => {
        socket?.destroy();
      };
    });

    return () => {};
  }, [easyXdmLoaded, easyXdmId]);

  return <div id={easyXdmId}></div>;
}
